<template>
  <div class="product-search">
    <input
      type="text"
      v-model="q"
      class="form-control form-control-lg mb-3 shadow-none product-search__input"
      placeholder="Search for a product..."
      autocorrect="off"
      autocomplete="off"
    />
    <ul v-if="results.length > 0" class="product-search__results list-group">
      <li
        v-for="result in results"
        class="product-search__result list-group-item"
        :key="result.item.productId"
        @click="$router.push({ name: 'product', params: { productId: result.item.productId } })"
      >
        <div
          class="product-search__result__img"
          :style="
            `background-image: url(https://storage.googleapis.com/emma-static/products/${result.item.img}_1200.jpg)`
          "
        />
        <div>
          <span>{{ result.item.name }}</span>
          <span class="badge badge-danger ml-1" v-if="result.item.status.discontinued">Discontinued</span>
          <span class="badge badge-warning ml-1" v-if="result.item.live && result.item.temporarilyUnavailable"
            >Temp. Unavailable</span
          >
          <small class="product-search__result__size">
            {{ result.item.packageSize }} {{ result.item.packageUnit }}
          </small>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Fuse from 'fuse.js'

export default {
  data() {
    return {
      q: '',
      results: []
    }
  },
  watch: {
    q() {
      this.search()
    }
  },
  methods: {
    search: _.throttle(function() {
      if (this.q.length > 2) {
        const products = this.$store.state.products
        Object.keys(products).forEach(i => {
          products[i].productId = products[i].id
          products[i].name = `${products[i].brandName} ${products[i].label}`
        })
        const fuse = new Fuse(products, {
          keys: ['name', 'productId'],
          threshold: 0.5,
          ignoreLocation: true,
          id: 'productId'
        })
        this.results = fuse.search(this.q, { limit: 5 })
      } else {
        this.results = []
      }
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.product-search {
  position: relative;

  &__input {
    font-size: 1.25rem;
  }

  &__results {
    position: absolute;
    right: 0;
    left: 0;
  }
  &__result {
    padding: 0.25rem;
    display: flex;
    align-items: center;

    &:hover {
      background: #f2f2f2;
      cursor: pointer;
    }

    &__img {
      width: 3rem;
      height: 3rem;
      margin: 0 1rem;
      display: inline-block;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    &__size {
      display: block;
      font-size: 0.75rem;
    }
  }
}
</style>
